
export enum HELP_ITEM_TYPE {
    INTRODUCTION = "introduction",
    LINQ_LANGUAGE = "linq-language",
    HOME_SCREEN = "home",
    CREATE_MODEL = "create-model",
    MODEL_SCREEN = "model-screen",
    PROJECTS = "projects",
    INSIGHTS = "insights",
    QUANTIFY_MODEL = "quantify-model",
    PEOPLE_SYSTEMS = "people-systems",
    DEMO_ORG = "demo",
    BILLING = "billing"
}

export const getHelpItemName = (type:HELP_ITEM_TYPE) => {
    switch(type) {
        case HELP_ITEM_TYPE.INTRODUCTION:
            return "Introduction"
        case HELP_ITEM_TYPE.LINQ_LANGUAGE:
            return "Introduction to LINQ language"            
        case HELP_ITEM_TYPE.HOME_SCREEN:
            return "Organisation home screen"            
        case HELP_ITEM_TYPE.CREATE_MODEL:
            return "Create a new model"
        case HELP_ITEM_TYPE.MODEL_SCREEN:
            return "Model screen"            
        case HELP_ITEM_TYPE.PROJECTS:
            return "Projects"
        case HELP_ITEM_TYPE.QUANTIFY_MODEL:
            return "Quantify a model"
        case HELP_ITEM_TYPE.INSIGHTS:
            return "Introduction to model insights"
        case HELP_ITEM_TYPE.PEOPLE_SYSTEMS:
            return "People and systems explained"
        case HELP_ITEM_TYPE.DEMO_ORG:
            return "Demo organisation"            
        case HELP_ITEM_TYPE.BILLING:
            return "Billing explained"            
    }
}

export enum TUTORIAL_TYPE {
    MODEL_INTRODUCTION = "model-introduction",
    QUANTIFY_MODEL = "quantify-model"
}

export const getTutorialSteps = (type:TUTORIAL_TYPE) => {
    switch (type) {
        case TUTORIAL_TYPE.MODEL_INTRODUCTION:
            return 6
        case TUTORIAL_TYPE.QUANTIFY_MODEL:
            return 5
    }
}

export const getTutorialName = (type:TUTORIAL_TYPE) => {
    switch(type) {
        case TUTORIAL_TYPE.MODEL_INTRODUCTION:
            return "Creating your first model"
        case TUTORIAL_TYPE.QUANTIFY_MODEL:
            return "Quantifying models - setting frequency and duration"
    
    }
}

export interface HelpItem {
    type:HELP_ITEM_TYPE,
    name:string,
    html:string,
    videoUrl:string
}

export interface TutorialStep {
    step:number,
    name:string,
    html:string,
    model:any,
    videoUrl:string
}

export interface Tutorial {
    type:TUTORIAL_TYPE,
    name:string,
    introduction:string,
    steps:TutorialStep[]
}
// a help guide as it's listed: the guides are held on the server and each one's page is fetched when it's opened
export interface HelpGuideSummary {
    slug:string
    title:string
    category:string
    summary:string
    keywords?:string[]
    // a help item whose video goes with the guide
    video?:HELP_ITEM_TYPE
}

export interface HelpGuide extends HelpGuideSummary {
    html:string
}

export interface HelpGuideSearchResult extends HelpGuideSummary {
    // the words around where the guide mentions what was searched for
    snippet:string
}
